// Copyright (c) 2016 Deere & Company

import './maintenance-plan-panel.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import MaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/maintenance-plan';
import MaintenancePlanItem from './maintenance-plan-item';

const MaintenancePlanPanel = ({maintenancePlans, isExpanded, onClick}) => {

    const maintenancePlansList = maintenancePlans.map(maintenancePlan =>
        <MaintenancePlanItem
            key={maintenancePlan.id}
            maintenancePlan={maintenancePlan}
        />
    );

    const maintenancePlansTitle = (
        <span className='maintenancePlan-title'>
            <FormattedMessage id='MAINTENANCE_PLAN'/>{` (${maintenancePlans.length})`}
        </span>
    );

    return (

        <Accordion
            accordionId='maintenance-plan-accordion'
            body={maintenancePlansList}
            isExpanded={isExpanded}
            onClick={onClick}
            title={maintenancePlansTitle}
        />

    );

};

MaintenancePlanPanel.displayName = 'MaintenancePlanPanel';
MaintenancePlanPanel.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    maintenancePlans: PropTypes.arrayOf(PropTypes.instanceOf(MaintenancePlan)).isRequired,
    onClick: PropTypes.func.isRequired
};
export default MaintenancePlanPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/maintenance-plan-panel.js